export const CONTENT_WIDTH: string = '1500px';
export const TILE_SIZE_LARGE = 3;
